module.exports = __webpack_public_path__ + "img/fengshimeng.9c8e594c.png";